import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { deleteDoc } from "firebase/firestore";
import {
  getContentDoc,
  getCouponsDoc,
  getDesignationDoc,
  getLifestyleDoc,
} from "../utils/firestoreHelpers";
import { useEffect } from "react";
import { BUSINESS, COUPON, DESIGNATIONS, LIFESTYLE } from "../utils/constants";

const DeleteModal = ({ onClose, data, type }) => {
  useEffect(() => {
    if (!type) onClose();
  }, [type, onClose]);

  const onDelete = async () => {
    if (type === BUSINESS) {
      const bussinessDoc = getContentDoc(data.id);
      await deleteDoc(bussinessDoc);
    }
    if (type === LIFESTYLE) {
      const lifestyleDoc = getLifestyleDoc(data.id);
      await deleteDoc(lifestyleDoc);
    }
    if (type === COUPON) {
      const lifestyleDoc = getCouponsDoc(data.id);
      await deleteDoc(lifestyleDoc);
    }
    if(type === DESIGNATIONS){
      const designationDoc = getDesignationDoc(data.id);
      await deleteDoc(designationDoc);
    }
    onClose();
  };

  if (!type) return null;

  return (
    <Modal show={true} onHide={() => {}}>
      <Modal.Header>
        <Modal.Title>Delete {type} data</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3" controlId="test">
          <label for="title" class="form-label d-block">
            Title
          </label>
          <input
            class="w-100 form-control"
            name="title"
            value={data.title}
            readOnly
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
        <Button variant="danger" onClick={onDelete}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteModal;
